<template>
  <div class="header-expanded-navigation__wrapper">
    <a-header-menu-block
      v-for="items in menuItemsForNavigationSections"
      :key="items[0].Name"
      :menu-items="items"
      @onCloseMenu="onCloseMenu"
    />

    <a-header-menu-block
      :menu-items="menuItemsForEventsSection"
      @onCloseMenu="onCloseMenu"
    />

    <a-header-menu-block
      :menu-items="menuItemsForContactSection"
      @onCloseMenu="onCloseMenu"
    />

    <ul class="header-mobile-expanded__menu-block-socials">
      <li v-for="social in socialList" :key="social.name">
        <a-link :to="social.link" class="single-social-btn">
          <a-icon
            :icon="social.icon"
            :width="15"
            :height="15"
            fill="#fff"
            class="social-icon"
          />
          <p class="social-title text-medium">
            {{ social.name }}
          </p>
        </a-link>
      </li>
    </ul>
  </div>
</template>

<script>
import AIcon from 'shared/AIcon/index.vue'
import AHeaderMenuBlock from '@/components/AHeader/AHeaderMobile/AHeaderMobileExpanded/AHeaderMenuBlock/index.vue'
import { FM_ROUTE, ROUTE } from 'enums/routes'
import { ICON } from 'shared/AIcon/enums'
import { PROP_TYPES, propValidator } from '@/utils/validators'
import mixins from '@/utils/mixins'

export default {
  name: 'HeaderExpandedNavigation',
  inheritAttrs: false,
  mixins: [mixins.urlGenerators],
  components: { AHeaderMenuBlock, AIcon },
  props: {
    menuList: propValidator([PROP_TYPES.ARRAY])
  },
  data() {
    return {
      expandedSectionIndex: null,
      socialList: [
        {
          name: 'Join investingLive News Updates',
          link: this.$env.IL_TELEGRAM_CHANNEL_FL,
          icon: ICON.TELEGRAM
        },
        {
          name: 'Join investingLive FX & Crypto',
          link: this.$env.IL_TELEGRAM_CHANNEL_CRYPTO,
          icon: ICON.TELEGRAM
        },
        {
          name: 'Follow us on Twitter',
          link: this.$env.IL_TWITTER_CHANNEL,
          icon: ICON.X_PURPLE
        },
        {
          name: 'Follow Us on Facebook',
          link: this.$env.IL_FACEBOOK_CHANNEL,
          icon: ICON.FACEBOOK
        }
      ]
    }
  },
  computed: {
    menuItemsForNavigationSections() {
      return this.menuList.map(item => [item])
    },
    slotNameForLastBlockItems() {
      return `bottom-items-0`
    },
    menuItemsForEventsSection() {
      return [
        {
          Name: 'Events',
          Link: this.generateFmUrl(FM_ROUTE.EVENTS)
        }
      ]
    },
    menuItemsForContactSection() {
      return [
        {
          Name: 'Contact Us',
          Link: ROUTE.CONTACT_US
        }
      ]
    }
  },
  methods: {
    onCloseMenu() {
      this.$emit('close-menu')
    }
  }
}
</script>

<style lang="scss" scoped>
.header-expanded-navigation__wrapper {
  .header-mobile-expanded__menu-block-socials {
    display: flex;
    flex-direction: column;
    padding: 12px 0 7px 0;
    border-bottom: 2px solid white;

    &:last-child {
      border-bottom: none;
    }
  }

  .header-mobile-expanded__premium-button {
    margin: 12px 0;
  }

  .social-title {
    transition: color 0.3s;
    color: $c--white;
  }

  .single-social-btn {
    display: flex;
    cursor: pointer;
    align-items: center;
    padding: 10px 0;

    &:hover {
      color: $c--gray-dark;
    }

    &.top {
      margin-top: 10px;
      padding-bottom: 0;
    }
  }

  .social-icon {
    margin-right: 10px;
  }
}
</style>
